import { render, staticRenderFns } from "./KT-Tasks.vue?vue&type=template&id=b890cb0c&lang=pug&"
import script from "./KT-Tasks.vue?vue&type=script&lang=js&"
export * from "./KT-Tasks.vue?vue&type=script&lang=js&"
import style0 from "./KT-Tasks.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports